import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { AppState } from '@app/store/app.state';
import {
  AuthSelectors,
  DocumentActions,
  DocumentSelectors,
  GlobalSelectors,
} from '@app/store';
import { DocumentDetailsModel } from '@app/core/models/document-details.model';
import { FileService } from '@app/core/services/file.service';
import { SharepointDocumentsService } from '@app/core/services/azure-functions/sharepoint-documents.service';
import { CP_PERMISSIONS } from '@app/shared/app.constants';

@Component({
  selector: 'app-documents-page',
  templateUrl: './documents-page.component.html',
  styleUrls: ['./documents-page.component.scss'],
})
export class DocumentsPageComponent implements OnInit, OnDestroy {
  documents$: Observable<DocumentDetailsModel[]> = this.store.select(
    DocumentSelectors.getDocuments
  );
  subscriptions: Subscription = new Subscription();
  searchValue = '';
  token = null;

  constructor(
    private store: Store<AppState>,
    private fileService: FileService,
    private sharepointDocumentService: SharepointDocumentsService
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.store
        .select(AuthSelectors.getUserPermissions)
        .pipe(
          switchMap(userPermissions =>
            this.store.select(GlobalSelectors.getSelectedGlobalFilters).pipe(
              filter(
                selectedBillingAcc =>
                  userPermissions.includes(CP_PERMISSIONS.DOCUMENTS_READ) &&
                  selectedBillingAcc.billingAccounts.length > 0
              ),
              distinctUntilChanged((prev, curr) => {
                return JSON.stringify(prev) === JSON.stringify(curr);
              })
            )
          )
        )
        .subscribe(selectedBillingAcc => {
          this.store.dispatch(
            DocumentActions.getDocuments({ requestBody: selectedBillingAcc })
          );
        })
    );
  }

  downloadDocument(documentId) {
    this.subscriptions.add(
      this.sharepointDocumentService
        .downloadDocument(documentId)
        .subscribe((downloadedDocument: DocumentDetailsModel) =>
          this.fileService.createAndDownloadBlobFile(
            downloadedDocument.content,
            downloadedDocument.documentName
          )
        )
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
